import * as Case from 'case';
import { StepsHelperComponent } from '~contentful/components/steps-helper/steps-helper.component';
import { ComponentModel } from '~contentful/models/components/component.model';
import { StepsHelperStepModel } from '~contentful/models/components/steps-helper-step.model';

export class StepsHelperModel extends ComponentModel {
  public readonly name: string;
  public readonly steps: StepsHelperStepModel[];
  public readonly hideOnMobile: boolean;
  public readonly hideOnTablet: boolean;
  public readonly hideOnDesktop: boolean;
  public readonly componentClass = StepsHelperComponent;

  public get contextLabel() {
    return this.name;
  }

  public get contextValue() {
    return Case.kebab(this.name);
  }
}
